export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  rating: number;
  views: string;
  year: number;
  description: string;
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-movie-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'kids', name: '少儿', icon: 'ri-bear-smile-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '流浪地球3',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20massive%20spaceship%20and%20earth%20in%20background%2C%20dramatic%20lighting%2C%20dark%20space%20atmosphere%2C%20epic%20scale%2C%20professional%20film%20poster%20style%2C%20warm%20orange%20and%20teal%20color%20grading%2C%20cinematic%20composition%2C%204K%20quality%20film%20still%20aesthetic&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '2h 28min',
    quality: '4K',
    rating: 9.1,
    views: '2.8亿',
    year: 2026,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开一场争分夺秒的生死之战。',
    tags: ['科幻', '冒险', '特效大片', '国产'],
  },
  {
    id: 'v2',
    title: '长安十二时辰',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20scene%20with%20traditional%20architecture%20and%20lanterns%20at%20night%2C%20warm%20golden%20lighting%2C%20historical%20costume%20drama%2C%20cinematic%20composition%2C%20dark%20moody%20atmosphere%2C%20film%20poster%20quality&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '48集',
    quality: '4K',
    rating: 8.8,
    views: '5.2亿',
    year: 2025,
    description: '唐朝天宝三年，上元节前夕，长安城陷入危局。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。',
    tags: ['古装', '悬疑', '历史', '国产'],
  },
  {
    id: 'v3',
    title: '深蓝星球',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20exotic%20marine%20life%2C%20crystal%20clear%20deep%20blue%20water%2C%20natural%20light%20rays%20piercing%20through%20water%20surface%2C%20BBC%20nature%20documentary%20quality%2C%20professional%20underwater%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '6集',
    quality: '4K',
    rating: 9.6,
    views: '1.5亿',
    year: 2026,
    description: '从热带珊瑚礁到极地冰海，从浅海到深渊，镜头带你潜入地球最神秘的水下世界，发现前所未见的海洋生命奇迹。',
    tags: ['自然', '海洋', 'BBC级别', '科普'],
  },
  {
    id: 'v4',
    title: '喜剧之王争霸赛',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20comedy%20variety%20show%20stage%20with%20bright%20spotlights%20and%20confetti%2C%20energetic%20performers%20on%20stage%2C%20vibrant%20entertainment%20atmosphere%2C%20TV%20show%20production%20quality%2C%20warm%20stage%20lighting%2C%20professional%20broadcast%20style&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '12期',
    quality: '1080P',
    rating: 8.5,
    views: '3.1亿',
    year: 2026,
    description: '全国顶尖喜剧人同台竞技，笑料不断，包袱不停。谁将成为新一代喜剧之王？每周五晚八点，爆笑来袭！',
    tags: ['喜剧', '竞技', '搞笑', '综艺'],
  },
  {
    id: 'v5',
    title: '龙族：火之晨曦',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20fantasy%20scene%20with%20a%20dragon%20soaring%20through%20clouds%20at%20sunset%2C%20stunning%20visual%20effects%2C%20anime%20art%20style%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20animation%20quality%2C%20professional%20anime%20key%20visual&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '24集',
    quality: '4K',
    rating: 9.3,
    views: '4.6亿',
    year: 2026,
    description: '平凡少年路明非意外收到卡塞尔学院的录取通知书，从此踏入了一个龙与混血种并存的奇幻世界，开启屠龙之旅。',
    tags: ['奇幻', '热血', '国产动漫', '小说改编'],
  },
  {
    id: 'v6',
    title: '小猪佩奇大冒险',
    category: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20colorful%20children%20animation%20scene%20with%20friendly%20animal%20characters%20in%20a%20sunny%20meadow%2C%20bright%20and%20cheerful%20colors%2C%20soft%20rounded%20art%20style%2C%20educational%20children%20content%20aesthetic%2C%20warm%20and%20inviting%20atmosphere&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '52集',
    quality: '1080P',
    rating: 9.0,
    views: '8.3亿',
    year: 2025,
    description: '可爱的小猪佩奇和她的家人朋友们一起探索世界，每一集都充满欢笑与温馨，是最适合学龄前儿童的启蒙动画。',
    tags: ['儿童', '启蒙', '亲子', '教育'],
  },
  {
    id: 'v7',
    title: '无名之辈2',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Gritty%20urban%20Chinese%20drama%20film%20scene%20in%20a%20narrow%20alley%20at%20night%20with%20neon%20signs%2C%20rain-slicked%20streets%2C%20noir%20lighting%2C%20character-driven%20cinematic%20composition%2C%20dark%20moody%20atmosphere%2C%20art%20house%20film%20poster%20quality&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '1h 55min',
    quality: '4K',
    rating: 8.7,
    views: '1.9亿',
    year: 2026,
    description: '一座小城，几个小人物。命运让他们相遇，在荒诞与温情交织的故事中，每个无名之辈都在努力活出自己的精彩。',
    tags: ['剧情', '黑色幽默', '文艺', '国产'],
  },
  {
    id: 'v8',
    title: '大明风华录',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20Ming%20dynasty%20imperial%20palace%20scene%20with%20elaborate%20costumes%20and%20ornate%20architecture%2C%20warm%20candlelight%20interior%2C%20historical%20Chinese%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20quality%2C%20epic%20scale&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '60集',
    quality: '4K',
    rating: 9.0,
    views: '6.7亿',
    year: 2025,
    description: '从永乐到正统，讲述大明王朝最辉煌也最动荡的六十年。朝堂权谋、战场厮杀、儿女情长，一幅波澜壮阔的历史画卷。',
    tags: ['历史', '古装', '权谋', '国产'],
  },
  {
    id: 'v9',
    title: '极地生存法则',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Arctic%20wilderness%20documentary%20scene%20with%20polar%20bears%20on%20ice%20floes%20under%20northern%20lights%2C%20frozen%20landscape%2C%20dramatic%20natural%20lighting%2C%20National%20Geographic%20quality%20photography%2C%20cold%20blue%20and%20white%20tones%2C%20epic%20scale&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '4集',
    quality: '4K',
    rating: 9.5,
    views: '9800万',
    year: 2026,
    description: '在地球最严酷的环境中，生命如何顽强生存？跟随镜头探索北极圈内动物们惊心动魄的生存故事。',
    tags: ['自然', '极地', '生存', '科普'],
  },
  {
    id: 'v10',
    title: '街舞风暴第二季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20competition%20stage%20with%20energetic%20dancers%20performing%20under%20colorful%20stage%20lights%2C%20urban%20culture%20vibe%2C%20professional%20TV%20production%20quality%2C%20dramatic%20spotlight%20effects%2C%20high-energy%20atmosphere&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '10期',
    quality: '1080P',
    rating: 8.3,
    views: '2.4亿',
    year: 2026,
    description: '全国最强舞者集结，国际顶尖裁判坐镇。Breaking、Popping、Locking，各舞种巅峰对决，燃爆整个夏天！',
    tags: ['街舞', '竞技', '潮流', '综艺'],
  },
  {
    id: 'v11',
    title: '仙王的日常生活',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20school%20life%20scene%20with%20magical%20elements%20and%20modern%20setting%2C%20vibrant%20colorful%20anime%20art%20style%2C%20light-hearted%20comedy%20mood%2C%20young%20characters%20with%20supernatural%20powers%2C%20professional%20anime%20quality&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '15集',
    quality: '4K',
    rating: 8.9,
    views: '3.8亿',
    year: 2025,
    description: '修真界的天才少年王令，为了过上平静的日常生活，拼命隐藏自己无敌的实力。但麻烦总是找上门来...',
    tags: ['搞笑', '校园', '修仙', '国产动漫'],
  },
  {
    id: 'v12',
    title: '超级飞侠环球记',
    category: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20airplanes%20and%20friendly%20robot%20characters%20flying%20over%20famous%20world%20landmarks%2C%20bright%20cheerful%20children%20animation%20style%2C%20educational%20global%20adventure%20theme%2C%20warm%20sunny%20sky%2C%20professional%20animation%20quality&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '40集',
    quality: '1080P',
    rating: 9.2,
    views: '7.1亿',
    year: 2026,
    description: '超级飞侠们再次出发！这次他们将带领小朋友们环游世界，了解各国文化，在冒险中学习成长。',
    tags: ['儿童', '冒险', '教育', '亲子'],
  },
  {
    id: 'v13',
    title: '深海危机',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intense%20underwater%20submarine%20disaster%20film%20scene%20with%20dark%20ocean%20depths%2C%20emergency%20red%20lights%2C%20dramatic%20tension%2C%20Hollywood%20blockbuster%20quality%2C%20claustrophobic%20atmosphere%2C%20professional%20cinematic%20composition&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '2h 5min',
    quality: '4K',
    rating: 8.4,
    views: '1.2亿',
    year: 2026,
    description: '深海科考队意外发现远古生物遗迹，一场与未知力量的生死较量在万米深海悄然展开。中国首部深海灾难大片！',
    tags: ['灾难', '科幻', '冒险', '国产'],
  },
  {
    id: 'v14',
    title: '舌尖上的故乡',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20scene%20with%20steaming%20traditional%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20fresh%20ingredients%2C%20authentic%20Chinese%20cooking%20aesthetic%2C%20professional%20food%20photography%2C%20rich%20textures&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '8集',
    quality: '4K',
    rating: 9.7,
    views: '2.2亿',
    year: 2025,
    description: '走遍中国大江南北，探寻每个地方最地道的家乡味道。一道菜，一个故事，一份乡愁，舌尖上的中国记忆。',
    tags: ['美食', '人文', '旅行', '纪录片'],
  },
  {
    id: 'v15',
    title: '遮天',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20cultivation%20fantasy%20animation%20scene%20with%20a%20warrior%20standing%20on%20a%20mountain%20peak%20under%20a%20cosmic%20sky%2C%20celestial%20phenomena%2C%20ancient%20Chinese%20mythology%20aesthetic%2C%20stunning%20visual%20effects%2C%20professional%20anime%20key%20visual&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '52集',
    quality: '4K',
    rating: 9.4,
    views: '5.5亿',
    year: 2026,
    description: '叶凡在泰山之巅意外被九龙拉棺带入星空古路，从此踏上了一条与众不同的修仙之路。诸天万界，唯我独尊！',
    tags: ['修仙', '玄幻', '热血', '国产动漫'],
  },
  {
    id: 'v16',
    title: '极限挑战第十季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20outdoor%20challenge%20scene%20with%20celebrity%20cast%20having%20fun%20in%20a%20colorful%20urban%20setting%2C%20bright%20daylight%2C%20energetic%20atmosphere%2C%20professional%20TV%20production%20quality%2C%20Chinese%20entertainment%20style&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    duration: '12期',
    quality: '1080P',
    rating: 8.6,
    views: '4.0亿',
    year: 2026,
    description: '经典国民综艺回归！六位固定成员加上飞行嘉宾，在中国各大城市展开脑力与体力的极限对决，笑料与感动并存。',
    tags: ['户外', '真人秀', '搞笑', '综艺'],
  },
];